import { ActionContext } from 'vuex'
import { RootState } from '@/types/store'

interface SwState {
  refreshing: boolean
  registration: ServiceWorkerRegistration
  updateExists: boolean
}

type SwContext = ActionContext<SwState, RootState>

export default {
  namespaced: true,
  modules: {
    //
  },
  state: () => ({
    refreshing: false,
    registration: null as ServiceWorkerRegistration | null,
    updateExists: false,
  }),
  getters: {
    // all: (state: SnackbarState) => state.items,
    // isRefreshing: (state: SwState) => state.refreshing,
    updateExists: (state: SwState) => state.updateExists,
    registration: (state: SwState) => state.registration,
  },
  mutations: {
    // remove(state: SnackbarState, uuid: string) {
    //   Vue.delete(state.items, state.items.findIndex(s => s.uuid == uuid))
    // },
    // add(state: SnackbarState, payload: SnackbarInterface) {
    //   state.items.push(payload)
    // },
    updateExists(state: SwState, reg: ServiceWorkerRegistration) {
      state.registration = reg
      state.updateExists = true
    },
    updateExistsOnly(state: SwState, val: boolean) {
      state.updateExists = val
    },
    // removeUpdateExists(state: SwState) {
    //   state.updateExists = false
    //   if (!state.registration || !state.registration.waiting) { return; }
    //   state.registration?.waiting?.postMessage('skipWaiting');
    // },
    setRefreshing(state: SwState, isRefreshing: boolean) {
      state.refreshing = isRefreshing
    },
  },
  actions: {
    removeUpdateExists({ state, commit }: SwContext) {
      commit('updateExistsOnly', false)
      // console.log('removeUpdateExists', state.registration, state.registration.waiting)
      // console.log(state.registration.waiting?.postMessage(''))
      if (!state.registration || !state.registration.waiting) {
        return
      }
      // state.registration?.waiting?.postMessage('skipWaiting');
      state.registration?.waiting?.postMessage({ type: 'SKIP_WAITING' })
    },
  },
}
